<template>
  <div
    class="ccui-multifunctional-table-wrapper  ccui-multifunctional-table-wrapper-detail"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in picketageList"
        :key="index"
        :label="item.packName"
        :name="item.packId"
      >
        <el-tabs v-model="picketaActiveName" @tab-click="tabClick(item)">
          <el-tab-pane label="股权关联" name="one">
            <div v-if="tabRefresh.one">
              <relationContent
                :relationData="relationData"
                :schemeId="schemeId"
                :packId="item.packId"
                :packName="item.packName"
                :relationType="'1'"
              ></relationContent>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="投资关联" name="tow">
            <div v-if="tabRefresh.tow">
              <relationContent
                :relationData="relationData"
                :schemeId="schemeId"
                :packId="item.packId"
                :packName="item.packName"
                :relationType="'2'"
              ></relationContent>
            </div>
          </el-tab-pane> -->
          <el-tab-pane label="人员任职关联" name="three">
            <div v-if="tabRefresh.three">
              <relationContent
                :relationData="relationData"
                :schemeId="schemeId"
                :packId="item.packId"
                :packName="item.packName"
                :relationType="'3'"
              ></relationContent>
            </div>
          </el-tab-pane>
          <el-tab-pane label="联系方式关联" name="four">
            <div v-if="tabRefresh.four">
              <relationContent
                :relationData="relationData"
                :schemeId="schemeId"
                :packId="item.packId"
                :packName="item.packName"
                :relationType="'4'"
              ></relationContent>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="dialogShow" width="30%">
      <p v-for="(item, index) in tips" :key="index">{{ item }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import relationContent from "./relationContent";
import { getWarningRelationshipList } from "@/app/sourcingFlow/api/expertEvaluation";
export default {
  name: "picketageRelationWarning",
  components: {
    relationContent
  },
  props: {
    schemeId: {
      type: String,
      default() {
        return "";
      }
    },
    packId: {
      type: String,
      default() {
        return "";
      }
    },
    sourceType: {
      type: String,
      default() {
        return "";
      }
    },
    picketageData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      relationData: [],
      picketageList: [],
      tabRefresh: {
        one: true,
        tow: false,
        three: false,
        four: false
      },
      activeName: "",
      picketaActiveName: "",
      innerActiveName: ["one", "tow", "three", "four"],
      innerActive: false,
      dialogShow: false,
      tips: []
    };
  },
  created() {
    // this.init();
  },
  watch: {
    picketageData: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.picketageList = newVal;
          this.activeName = newVal[0].packId;
          this.picketaActiveName = this.innerActiveName[0];
          console.log("picketageList", newVal);
          // this.getList("1", newVal[0].packId);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init() {
      this.getList("1", this.picketageData[0].packId);
    },
    handleClick(tab) {
      this.picketaActiveName = this.innerActiveName[0];
      this.tabRefresh.one = true;
      this.getList("1", tab.name);
      console.log(tab, "tabRefresh");
    },
    tabClick(item) {
      switch (this.picketaActiveName) {
        case "one":
          this.switchTab("one", item.packId);
          break;
        case "tow":
          this.switchTab("tow", item.packId);
          break;
        case "three":
          this.switchTab("three", item.packId);
          break;
        case "four":
          this.switchTab("four", item.packId);
          break;
        default:
      }
    },
    switchTab(tab, packId) {
      console.log(tab, "switchTab");
      for (let [key] of Object.entries(this.tabRefresh)) {
        if (key == tab) {
          if (key == "one") {
            this.relationData = [];
            this.getList("1", packId);
            this.tabRefresh[key] = true;
          } else if (key == "tow") {
            this.relationData = [];
            this.getList("2", packId);
            this.tabRefresh[key] = true;
          } else if (key == "three") {
            this.relationData = [];
            this.getList("3", packId);
            this.tabRefresh[key] = true;
          } else if (key == "four") {
            this.relationData = [];
            this.getList("4", packId);
            this.tabRefresh[key] = true;
          }
        } else {
          this.tabRefresh[key] = false;
        }
      }
    },
    getList(relationType, packId) {
      getWarningRelationshipList({
        schemeId: this.schemeId,
        packId: packId,
        type: relationType,
        percent: "50",
        phaseType: "8",
        isShowLoading: true
      }).then(res => {
        if (res.data.code == "0") {
          this.relationData = res.data.data.list;
          console.log(relationType, this.relationData, "relationType");
          if (res.data.data.tips) {
            this.dialogShow = true;
            this.tips = res.data.data.tips.split("-");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tabs__content {
  margin-top: 35px !important;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
.ccui-multifunctional-table-wrapper /deep/.el-dialog {
  overflow: hidden;
  width: 50% !important;

  .el-dialog__body {
    max-height: auto !important;
    height: auto !important;
  }
}
</style>
